/** biome-ignore-all lint/complexity/noExcessiveLinesPerFunction: TODO: refactor functions */
/** biome-ignore-all lint/style/noMagicNumbers: investigate */
import { groupBy, maxBy, orderBy, sum, sumBy } from 'es-toolkit';
import moment from 'moment';

import { arrayMove } from '@/utils/array';
import {
  convertLocalToUTC,
  formatDate,
  getLocalDateTime,
  getLocalTimeZone,
  ISO_DATETIME_NO_TZ_FORMAT,
} from '@/utils/date';
import { generateUUIDv4 } from '@/utils/number';

import { SP_CARRIERS_TYPES } from '../contants/common';
import {
  SHIPMENT_TRANSPORTATION_ADDITIONAL_INFO_POST,
  SHIPMENT_TRANSPORTATION_OBJECTS,
  SHIPMENT_TRANSPORTATION_TYPES,
  SHIPMENT_TRANSPORTATION_TYPES_ID,
} from '../contants/Fields';
import { SHIPMENT_RATE_SHOP_RATTING_PREFERENCES } from '../contants/ShipmentEnums';
import {
  combineDateTimeMoment,
  convertDateESTToUTCToUserLocal,
  convertDateStringtoMoment,
  convertDateToMoment,
  convertDateUserLocalToUTCToEST,
  convertDateUTCToUserLocal,
  convertLocalToEST,
  convertTimetoMoment,
  convertUserLocalToEST,
  dateTimeToSingleValue,
  formateWithMoment,
  getFormattedTimeString,
  mergeDateAndTimeObjectsWithTimeZone,
  truncateTimeZoneDate,
} from './dates';
import { nullToValue, stringToNull, trimObjectValues, valueToNull, valueToNumber, valueToString } from './format';
import { calCulateFreightClass, getRateShopStringAll, validateProductForCalculateClass } from './utilz';

const convertAdditionalDetailsToLocal = (shipment) => {
  return {
    accountNumber: shipment.accountNumber,
    bolNumber: shipment.bolNumber,
    branchDesc: shipment.branchDesc,
    branchKey: shipment.branchKey,
    cargoType: shipment.cargoType,
    cargoTypeDesc: shipment.cargoTypeDesc,
    carrierKey: valueToNull(shipment.carrierKey),
    carrierName: shipment.carrierName,
    createdBy: valueToNull(shipment.createdBy),
    createdByName: shipment.createdByName,
    createdOn: convertDateStringtoMoment(shipment.createdOn),
    currencyCode: shipment.currencyCode,
    fobCode: shipment.fobCode,
    freightAllowance: shipment.freightAllowance,
    hazmatContactName: shipment.hazmatContactName,
    incoCode: shipment.incoCode,
    incoPoint: shipment.incoPoint,
    incoTerms: shipment.incoTerms,
    isChildShipment: shipment?.isChildShipment === 'Y',
    isMasterShipment: shipment?.isMasterShipment === 'Y',
    lspStationCode: shipment.lspStationCode || null,
    masterBolNumber: shipment.masterBolNumber,
    modifiedBy: valueToNull(shipment.modifiedBy ? valueToNumber(shipment.modifiedBy) : shipment.modifiedBy),
    modifiedByName: shipment.modifiedByName,
    modifiedOn: convertDateStringtoMoment(shipment.modifiedOn),
    nlccApproverUserId: shipment.nlccApproverUserId || null,
    nlccRequestorEmail: shipment.nlccRequestorEmail?.trim(),
    paidAmount: shipment.paidAmount,
    paymentTerms: shipment.paymentTerms,
    pickupConfirmationNumber: shipment.pickupConfirmationNumber,
    poNumber: shipment.poNumber,
    proNo: shipment.proNo,
    purchaseOrderNumber: shipment.purchaseOrderNumber,
    rateShopCost: shipment.rateShopCost,
    salesOrderNumber: shipment.salesOrderNumber,
    serviceType: shipment.serviceType,
    shipmentCost: shipment.shipmentCost,
    shipmentOriginator: shipment.shipmentOriginator,
    shipmentTerms: shipment.shipmentTerms,
    shipmentTermsDesc: shipment.shipmentTermsDesc,
    shipmentType: shipment.shipmentType,
    shipmentTypeDesc: shipment.shipmentTypeDesc,
    status: shipment.status,
    trailerNumber: shipment.trailerNumber,
    transportationPO: shipment.transportationPO,
  };
};

const convertTransportationToLocal = (shipment) => {
  const localData = [];
  for (const key in SHIPMENT_TRANSPORTATION_OBJECTS) {
    const value = SHIPMENT_TRANSPORTATION_OBJECTS[key];
    if (Object.hasOwn(shipment, value)) {
      const rows = shipment[value];
      rows?.forEach((row) => {
        let data = {};
        data.transportationType = SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS[key]];

        const TypeNo = SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS[key]];
        const Type =
          TypeNo === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
            ? { additional: 'originAdditionalInfo', short: 'shipper' }
            : { additional: 'destinationAdditionalInfo', short: 'consignee' };

        data.stopType = valueToString(SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS[key]]);
        data.appointmentNo = row[`${Type.short}ReferenceNo`];
        data.primaryKey = row[`${Type.short}Key`];
        data.appointmentType = row[`${Type.short}AppointmentType`];
        data.siteId = row[`${Type.short}siteId`];

        data.requestedDate = convertDateUTCToUserLocal(
          row[Type.additional][`${TypeNo === 1 ? 'shipperRequestedShipDate' : 'shipperRequestedDeliveryDate'}`],
        );

        data.requestedTime = convertDateUTCToUserLocal(
          row[Type.additional][`${TypeNo === 1 ? 'shipperRequestedShipDate' : 'shipperRequestedDeliveryDate'}`],
        );

        data.appointmentDate = convertDateUTCToUserLocal(
          row[Type.additional][`${TypeNo === 1 ? 'carrierAppontmentShipDate' : 'carrierAppontmentDeliveryDate'}`],
        );

        data.appointmentTime = convertDateUTCToUserLocal(
          row[Type.additional][`${TypeNo === 1 ? 'carrierAppontmentShipDate' : 'carrierAppontmentDeliveryDate'}`],
        );

        data.actualDate = convertToMoment(
          row[Type.additional][`${TypeNo === 1 ? 'carrierActualShipDate' : 'carrierActualDeliveryDate'}`],
        );

        data.actualTime = convertToMoment(
          row[Type.additional][`${TypeNo === 1 ? 'carrierActualShipDate' : 'carrierActualDeliveryDate'}`],
        );

        data = {
          ...data,
          ...row[Type.additional],
          ...getDecodeWeeklyDaysOperation(row.weeklyOperation),
          ...getDecodeWeeklyHoursOperation(row.hoursOperation),
        };
        data.shipmentKey = row.shipmentKey;
        data.id = row.id;
        data.legNumber = row.legNumber;
        data.sequence = valueToString(row.sequence);
        data.searchId = row.searchId;
        data.name = row.name;
        data.address1 = row.address1;
        data.address2 = row.address2;
        data.zipCode = row.zipCode;
        data.city = row.city;
        data.stateCode = row.stateCode;
        data.countryCode = row.countryCode;
        data.businessPhone = row.businessPhone;
        data.matchedBolKey = row.matchedBolKey;
        data.portName = row.portName || null;
        data.portType = row.portType?.trim() || null;
        data.portCode = row.portCode || null;
        data.portRecKey = row.portRecKey;
        data.countryName = row.countryName;
        data.stateName = row.stateName;
        data.hrsOfOperation = row.hrsOfOperation;
        data.weeklyOperation = row.weeklyOperation;
        data.hoursOperation = row.hoursOperation;
        data.legMiles = row.legMiles;
        data.customerKey = row.customerKey;
        data.oldStopSequence = row.oldStopSequence;
        data.createdBy = row.createdBy;
        data.extension = row.extension;
        data.dockNumber = row.dockNumber;
        data.displaySequence = valueToString(row.displaySequence);
        data.gridOperation = 2;
        data.isResetNew = 0;
        data.latitude = row.latitude;
        data.longitude = row.longitude;
        data.totalWeight = row.totalWeight;
        for (const key in data) {
          if (typeof data[key] === 'string') {
            data[key] = data[key].trim();
          }
        }

        localData.push(data);
        data.shipperAppointmentType = row.shipperAppointmentType;
        data.consigneeAppointmentType = row.consigneeAppointmentType;
        data.trailerNumber = row.trailerNumber;
        data.isModifiedDateTime = row[Type.additional].isModifiedDateTime;

        if (TypeNo === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]) {
          data.shipperLocationId = row.shipperLocationId;
        } else {
          data.consigneeLocationId = row.consigneeLocationId;
        }
      });
    }
  }
  return orderBy(localData, ['displaySequence'], ['asc']);
};

export const convertShipmentApiResponseToLocal = (shipment) => {
  return {
    ...shipment,
    additionalDetails: convertAdditionalDetailsToLocal(shipment),
    rateShopList: shipment.rateShopDetails?.map((row) => ({
      ...row,
      accessorials: row.freightAccessorialCollection
        ? row.freightAccessorialCollection?.map((row) => ({
            ...row,
            auditedChargeAmount: row.cost,
            currencyCode: row.currency,
            description: row.costName,
          }))
        : [],
      createdOn: convertDateESTToUTCToUserLocal(row.createdOn),
      effectiveTo: convertDateESTToUTCToUserLocal(row.effectiveTo),
    })),
    shipmentBillingDetails: shipment.shipmentBillToInfo,
    shipmentCategoryList: shipment.hierarchialDetails,
    shipmentFilesList: shipment.shipmentDocuments.map((row) => ({
      renderKey: generateUUIDv4(),
      ...row,
    })),
    shipmentVendorList: shipment.shipmentVendorDetails,
    taxes: shipment.shipmentTaxes,
    transportationList: convertTransportationToLocal(shipment),
  };
};

export const getDecodeWeeklyDaysOperation = (_date = '') => {
  const date = _date || '';
  let [fromOperationDay, toOperationDay] = String(date || '')
    .split('TO')
    .map((ele) => (ele.trim()?.length > 0 ? ele.trim() : undefined));
  fromOperationDay = String(fromOperationDay) === 'undefined' ? undefined : fromOperationDay;
  toOperationDay = String(toOperationDay) === 'undefined' ? undefined : toOperationDay;
  return { fromOperationDay, toOperationDay };
};

export const getDecodeWeeklyHoursOperation = (_date = '') => {
  const date = _date || '';
  const [fromOperationHours, toOperationHours] = String(date || '')
    .split('TO')
    .map((ele) => (ele.trim()?.length > 0 ? ele.trim() : undefined));
  return {
    fromOperationHours: fromOperationHours ? convertTimetoMoment(fromOperationHours) : '',
    toOperationHours: toOperationHours ? convertTimetoMoment(toOperationHours) : '',
  };
};

const convertToMoment = (date) => {
  if (!date) {
    return undefined;
  }
  return convertDateESTToUTCToUserLocal(date);
};

export const getShipmentTypeCounts = (type, listData) =>
  listData?.filter((data) => data.transportationType === type).length;

// ----------------Converting local data to API-----------------
export const convertShipmentDetailsLocalToAPI = ({ action, customerKey, masterShipment, ...data }) => {
  const userInfo = localStorage.getItem('userInfo');
  const userId = (userInfo ? JSON.parse(userInfo) : {}).id;
  let newData = {
    action,
    userId,
  };

  newData.shipmentInformationRequest = convertAdditionalDetailsLocalToAPI(
    data.additionalDetails,
    data,
    customerKey,
    data.shipmentKey,
    data.shipmentNo,
    userId,
    data.approvalNumber,
    masterShipment,
  );

  newData = {
    ...newData,
    ...convertTransportationListLocalToAPI(data.transportationList, userId),
    ...fixedData,
  };

  newData.shipmentProductInformation = convertProductLocalToAPI(data.productList, data.shipmentKey, userId);
  newData.shipmentBillToRequestInformation = convertBillLocaltoAPI(data.shipmentBillToInfo, data.shipmentKey, userId);
  newData.shipmentVendorRequestInformation = convertVendorLocalToAPI(data.shipmentVendorList, data.shipmentKey, userId);
  newData.shipmentDocumentInformation = convertDocumentsLocalToApiForAddShipment(data.documentList);
  newData.shipmentCategoryInformation = convertCategoryLocalToAPI(
    data.shipmentCategoryInformation,
    data.shipmentKey,
    userId,
  );
  newData.shipmentAccessorialInformation = data.accessorials
    ? data?.accessorials?.map((row) => ({
        accChargeAmount: valueToNumber(row?.accChargeAmount),
        accChargeType: row?.codeId,
        codeDesc: valueToString(row?.codeDesc),
        createdBy: userId,
        createdOn: moment(getLocalDateTime()),
        gridOperation: 1,
        lookupKey: valueToNumber(row?.lookupKey),
        shipmentKey: 0,
      }))
    : [];
  newData.shipmentTaxInformation = data.taxes
    ? data?.taxes?.map((row, index) => ({
        createdBy: userId,
        createdOn: moment(getLocalDateTime()),
        gridOperation: 2,
        sequence: index + 1,
        shipmentKey: 0,
        taxAmount: valueToNumber(row?.taxAmount),
        taxTypeCode: valueToString(row?.taxTypeCode),
      }))
    : [];

  newData.shipmentRateShopInformation =
    data?.shipmentRateShopInformation?.length > 0 ? data?.shipmentRateShopInformation : [];

  return newData;
};

const convertCategoryLocalToAPI = (data, shipmentKey, userId) => {
  const newData = [];

  data?.forEach((row) => {
    newData.push({
      createdBy: valueToNumber(userId),
      gridOperation: valueToNumber(nullToValue(row.gridOperation)),
      heirDetSequence: valueToNumber(nullToValue(row.heirDetSequence)),
      hierLookupDetKey: valueToNumber(nullToValue(row.hierLookupDetKey)),
      hierLookupDetKeyParent: valueToNumber(nullToValue(row.hierLookupDetKeyParent)),
      hierLookupDetName: valueToString(row.hierLookupDetName),
      hierLookupDetNameParent: valueToString(row.hierLookupDetNameParent),
      hierLookupKey: valueToNumber(nullToValue(row.hierLookupKey)),
      hierLookupName: valueToString(row.hierLookupName),
      shipmentHierarchyDetailsId: valueToNumber(nullToValue(row.shipmentHierarchyDetailsId)),
      shipmentKey: valueToNumber(shipmentKey),
    });
  });

  return newData;
};

const convertVendorLocalToAPI = (data, shipmentKey, userId) => {
  const newData = [];
  data?.forEach((row) => {
    newData.push({
      city: valueToString(row.city),
      countryCode: valueToString(row.countryCode),
      countryName: valueToString(row.countryName),
      createdBy: valueToNumber(data.isNew ? userId : data.createdBy),
      gridOperation: valueToNumber(row.gridOperation),
      id: valueToNumber(row.id),
      postalCode: valueToString(row.postalCode),
      shipmentKey: valueToNumber(shipmentKey),
      stateCode: valueToString(row.stateCode),
      stateName: valueToString(row.stateName),
      vendorEmail: valueToString(row.vendorEmail),
      vendorKey: valueToNumber(row.vendorKey),
      vendorName: valueToString(row.vendorName),
      vendorPhone: valueToString(row.vendorPhone),
    });
  });

  return newData;
};

const convertAdditionalDetailsLocalToAPI = (
  data,
  mainData,
  customerKey,
  shipmentKey,
  shipmentNo,
  userId,
  approvalNumber,
  masterShipment,
) => {
  if (!data) {
    return {};
  }
  const newData = {
    accountNumber: data.accountNumber,
    approvalNumber: valueToString(approvalNumber),
    bolNumber: data.bolNumber,
    branchKey: data.branchKey,
    cargoType: valueToString(mainData.cargoType?.[0]),
    carrierKey: 0,
    carrierRequirements: valueToString(mainData.carrierRequirements),
    createdBy: userId,
    currencyCode: data.currencyCode,
    customerContact: data.customerContact,
    customerKey,
    detailNotes: valueToString(mainData.detailNotes),
    expDeliveryDate: '2022-09-05T10:46:14.373Z',
    expShipDate: '2022-09-05T10:46:14.373Z',
    fobCode: data.fobCode,
    freightAllowance: data.freightAllowance,
    incoCode: data.incoCode?.trim(),
    incoPoint: data.incoPoint,
    lspStationCode: data.lspStationCode,
    masterBolNumber: data.masterBolNumber,
    masterShipment: masterShipment === true ? 1 : 0,
    masterShipmentCurrentQty: 0,
    masterShipmentCurrentWeight: 0,
    nlccApproverUserId: data.nlccApproverUserId,
    nlccRequestorEmail: data.nlccRequestorEmail,
    paidAmount: valueToNumber(data.paidAmount),
    paymentTerms: valueToString(data.paymentTerms),
    projectNo: '',
    proNo: data.proNo,
    purchaseOrderNumber: valueToString(data.purchaseOrderNumber),
    quoteNo: '',
    rateShopCost: 0,
    rateShopKey: 0,
    requiredCarrierKey: valueToNumber(mainData.requiredCarrierKey),
    salesOrderNumber: valueToString(data.salesOrderNumber),
    serviceKey: valueToNumber(mainData.serviceKey),
    serviceType: data.serviceType,
    shipmentKey,
    shipmentNo: valueToString(shipmentNo),
    shipmentNotes: valueToString(mainData.shipmentNotes),
    shipmentTerms: data.shipmentTerms,
    shipmentType: data.shipmentType,
    specialServices: '',
    status: data.status,
    trackingDateTime: '2022-09-05T10:46:14.373Z',
    trailerId: valueToNumber(mainData.trailerKey),
    trailerNumber: data.trailerNumber,
    transportationMode: '',
    transportationPO: data.transportationPO,
  };

  return newData;
};

const convertProductLocalToAPI = (_data, shipmentKey, userId) => {
  let data = _data || [];
  data = data.map(({ createdBy, ...row }) => ({
    accessorialData: Number(row.accessorialData?.qty)
      ? {
          qty: Number(row.accessorialData.qty),
          uom: row.accessorialData.uom ?? null,
        }
      : null,
    actualWeight: 0,
    billQty: valueToNumber(row.billQty),
    billQtyUom: valueToString(row.billQtyUom),
    billQtyUomName: valueToString(row.billQtyUomName),
    book: valueToNumber(row.book),
    bookOks: valueToNumber(row.bookOks),
    cartonQty: 0,
    cartonUOM: '',
    class: valueToString(row.class),
    className: valueToString(row.className),
    countryOfOrigin: valueToString(row.countryOfOrigin),
    crateNo: valueToString(row.crateNo),
    createdBy: valueToNumber(row.shipmentDetailsID ? createdBy : userId),
    cube: valueToNumber(valueToNull(row.cube)),
    deliveryID: '',
    dimUom: valueToString(row.dimUom),
    dimUomName: valueToString(row.dimUomName),
    eccn: valueToString(row.eccn),
    gridOperation: valueToNumber(row.gridOperation),
    hazmat: valueToString(row.hazmat),
    hazmatUnNo: valueToString(row.hazmatUnNo),
    height: valueToNumber(row.height),
    hts: valueToString(row.hts),
    itemSequenceKey: valueToNumber(row.itemSequenceKey),
    length: valueToNumber(row.length),
    misc: valueToNumber(row.misc),
    miscOKs: valueToNumber(row.miscOKs),
    nmfcNumber: valueToString(row.nmfcNumber),
    palletLoadType: valueToString(row.palletLoadType),
    palletPackageType: valueToString(row.palletPackageType),
    poNumber: valueToString(row.poNumber),
    productCode: valueToString(row.productCode),
    productDescription: valueToString(row.productDescription),
    quantity: valueToNumber(row.quantity),
    reference1: valueToString(row.reference1),
    shipmentDetailsID: valueToNumber(row.shipmentDetailsID),
    shipmentKey: valueToNumber(shipmentKey),
    soft: valueToNumber(row.soft),
    softOks: valueToNumber(row.softOks),
    soNumber: valueToString(row.soNumber),
    stcDescription: valueToString(row.stcDescription),
    unitMeasure: valueToString(row.unitMeasure),
    unitMeasureName: valueToString(row.unitMeasureName),
    unitPrice: valueToNumber(row.unitPrice),
    weight: valueToNumber(row.weight),
    weightUom: valueToString(row.weightUom),
    weightUomName: valueToString(row.weightUomName),
    width: valueToNumber(row.width),
  }));
  return data;
};
const convertTransportationListLocalToAPI = (data, userID, customerKey) => {
  const newData = {
    shipmentDestinationInformation: [],
    shipmentOriginInformation: [],
  };

  data?.forEach(({ stopType, portRecKey, ...row }) => {
    const params =
      Number(stopType) === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
        ? {
            actualDate: 'carrierActualShipDate',
            additionalInfo: 'shipmentOriginAdditionalInformation',
            appointmentDate: 'carrierAppontmentShipDate',
            key: 'originKey',
            requestedDate: 'shipperRequestedShipDate',
          }
        : {
            actualDate: 'carrierActualDeliveryDate',
            additionalInfo: 'shipmentDestinationAdditionalInformation',
            appointmentDate: 'carrierAppontmentDeliveryDate',
            key: 'destinationKey',
            requestedDate: 'shipperRequestedDeliveryDate',
          };
    newData[SHIPMENT_TRANSPORTATION_ADDITIONAL_INFO_POST[SHIPMENT_TRANSPORTATION_TYPES_ID[stopType]]].push({
      addr1: row.address1,
      addr2: row.address2,
      city: row.city,
      countryCode: row.countryCode,
      createdBy: nullToValue(userID),
      customerKey,
      displaySequence: valueToNumber(nullToValue(row.displaySequence)),
      gridOperation: nullToValue(row.gridOperation),
      legNumber: row.legNumber,
      name: row.name,
      oldStopSequence: nullToValue(row.oldStopSequence),
      portRecKey: nullToValue(valueToNumber(portRecKey)),
      portType: row.portType || '',
      searchId: row.searchId,
      sequence: valueToNumber(nullToValue(row.sequence)),
      shipmentKey: row.shipmentKey,
      shipRecKey: row.shipRecKey,
      state: row.stateCode,
      stopType,
      zip: row.zipCode,
      [params.additionalInfo]: {
        displaySequence: valueToNumber(nullToValue(row.displaySequence)),
        sequence: valueToNumber(nullToValue(row.sequence)),
        shipmentKey: row.shipmentKey,
        [params.requestedDate]: row.requestedDate
          ? formatDate(
              convertLocalToUTC(dateTimeToSingleValue(row.requestedDate, row.requestedTime)),
              ISO_DATETIME_NO_TZ_FORMAT,
            )
          : null,
        [params.appointmentDate]: row.appointmentDate
          ? formatDate(
              convertLocalToUTC(dateTimeToSingleValue(row.appointmentDate, row.appointmentTime)),
              ISO_DATETIME_NO_TZ_FORMAT,
            )
          : null,
        [params.actualDate]: row.actualDate
          ? getFormattedTimeString(convertLocalToEST(dateTimeToSingleValue(row.actualDate, row.actualTime)))
          : null,
        appointmentType: row.appointmentType,
        contactEmail: row.contactEmail,
        contactName: row.contactName,
        createdBy: nullToValue(userID),
        dockNumber: row.dockNumber,
        doorDockID: row.doorDockID,
        extension: row.extension,
        gridOperation: nullToValue(row.gridOperation),
        hoursOfOperation: `${valueToString(row.fromOperationDay)} TO ${valueToString(
          row.toOperationDay,
        )} | ${convertOperationHoursTime(
          row.fromOperationHours,
        )} TO ${convertOperationHoursTime(row.toOperationHours)}`,
        isResetNew: row.isResetNew,
        legMiles: row.legMiles,
        oldStopSequence: row.oldStopSequence,
        phone: row.phone,

        pickupDeliveryID: row.appointmentNo,
        taxId: row.taxId,
        uom: row.uom,
      },
      countryName: row.countryName,
      isResetNew: row.isResetNew,
      portName: row.portName,
      stateName: row.stateName,
      trailerNumber: valueToString(row.trailerNumber),
      ...(Number(stopType) === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
        ? {
            shipperLocationId: row.shipperLocationId || '',
          }
        : { consigneeLocationId: row.consigneeLocationId || '' }),
    });
  });

  return newData;
};

const convertDocumentsLocalToApiForAddShipment = (data) => {
  return data
    ? data.map((row, index) => ({
        documentDesc: valueToString(row.documentDesc),
        documentFileName: valueToString(row.file),
        documentSequence: index + 1,
        documentTitle: valueToString(row.documentTitle),
        documentTypeCode: valueToString(row.docTypeCode),
        fileExtension: `.${valueToString(row.file).split('.').pop()}`,
        filePath: row?.fileBase64?.trim() !== '' ? row.fileBase64.split(',')[1] : '',
        isCarrierVisible: Boolean(row.isCarrierVisible),
        isVendorVisible: Boolean(row.isVendorVisible),
        originalFileName: valueToString(row.file),
        referenceNo: valueToString(row.referenceNo),
      }))
    : [];
};
const convertOperationHoursTime = (time) => {
  if (time) {
    return time.format('hh:mm A');
  }
  return ' ';
};

const convertBillLocaltoAPI = (data, shipmentKey, userId) => {
  return {
    address1: valueToString(data?.address1),
    address2: valueToString(data?.address2 ? data?.address2 : ' '),
    city: valueToString(data?.city),
    contact: valueToString(data?.contact),
    contactEmail: valueToString(data?.contactEmail),
    countryCode: valueToString(data?.countryCode),
    countryName: valueToString(data?.countryName),
    createdBy: userId,
    name: valueToString(data?.name),
    postalCode: valueToString(data?.postalCode),
    shipmentKey,
    stateCode: valueToString(data?.stateCode),
    stateName: valueToString(data?.stateName),
    vatNumber: valueToString(data?.vatNumber),
  };
};

const fixedData = {
  purchaseSalesOrderInformation: [],
  shipmentDocumentInformation: [],
};

export const calculateSequenceAndDisplaySequence = (_transportationList) => {
  let transportationList = _transportationList || [];
  const totalPickups = transportationList?.filter(({ sequence }) => sequence === '1').length;
  const totalDeliveries = transportationList?.filter(({ sequence }) => sequence === '99').length;

  const destinationIndex = transportationList?.findIndex(({ sequence }) => sequence === '99');
  const newItemIndex = transportationList?.findIndex(({ isNew }) => isNew);
  let newItemSequence = 0;
  const newItemDisplaySequence = transportationList.length - (totalDeliveries > 0 ? 1 : 0);

  const getSequence = (index, isPickup) => {
    if (isPickup) {
      const pickupIndex = index >= 0 ? index : transportationList.length;
      return valueToNumber(transportationList[pickupIndex - 1].sequence) + 1;
    }
    return valueToNumber(transportationList[index - 1].sequence) + 1;
  };

  if (newItemIndex >= 0) {
    if (
      Number(transportationList[newItemIndex].stopType) ===
      SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
    ) {
      newItemSequence = totalPickups > 0 ? getSequence(destinationIndex, true) : '1';
    } else {
      newItemSequence = totalDeliveries > 0 ? getSequence(destinationIndex, true) : '99';
    }
  }

  transportationList[newItemIndex] = {
    ...transportationList[newItemIndex],
    displaySequence: valueToString(newItemDisplaySequence),
    sequence: valueToString(newItemSequence),
  };

  if (totalDeliveries > 0) {
    transportationList[destinationIndex] = {
      ...transportationList[destinationIndex],
      displaySequence: valueToString(transportationList.length),
    };
  }

  let sequence = 0;
  transportationList = transportationList.map((row) => {
    if (Number(row.sequence) !== 99) {
      sequence += 1;
    }
    return {
      ...row,
      sequence: Number(row.sequence) === 99 ? 99 : sequence,
    };
  });
  return transportationList;
};

export const convertRateEngineApiResponseToShipmentLocal = (_data, isAPIRateShop) => {
  let data = _data || _data;
  if (data) {
    data = data.map((row) => {
      const accessorialsList = (row.accessorials ?? row.Accessorials ?? []).map((acc) => ({
        AccessorialDetailKey: acc.accessorialDetailKey ?? acc.AccessorialDetailKey,
        AccessorialKey: acc.accessorialKey ?? acc.AccessorialKey,
        accessorialCode: acc.accessorialCode ?? acc.AccessorialCode,
        auditedChargeAmount: valueToNumber(acc.auditedChargeAmount ?? acc.AuditedChargeAmount),
        CurrencyExchangeCode: acc.CurrencyExchangeCode ?? acc.currencyExchangeCode,
        CurrencyExchangeRate: acc.CurrencyExchangeRate ?? acc.currencyExchangeRate,
        currencyCode: acc.currencyCode ?? acc.CurrencyCode,
        description: acc.description ?? acc.Description,
      }));
      return {
        accessorialCost: sum(accessorialsList.map(({ auditedChargeAmount }) => auditedChargeAmount)),
        accessorials: [
          {
            accessorialCode: 'FREIGHT',
            auditedChargeAmount: row.absTotalCharge ?? row.ABSTotalCharge,
            currencyCode: row.currencyCode ?? row.CurrencyCode,
            description: 'FREIGHT CHARGE',
          },
          ...orderBy(accessorialsList, ['description'], ['asc']),
        ],
        bidComment: row.errorMessage ?? row.ErrorMessage,
        CurrencyConversion: row.currencyConversion ?? row.CurrencyConversion,
        CurrencyExchangeCode: row.currencyExchangeCode ?? row.CurrencyExchangeCode,
        CurrencyExchangeRate: row.currencyExchangeRate ?? row.CurrencyExchangeRate,
        CustomerNotes: row.customerNotes ?? row.CustomerNotes,
        cargoType: row.cargoType ?? row.CargoType,
        carrierKey: row.carrierKey ?? row.CarrierKey,
        carrierName: row.carrierName ?? row.CarrierName,
        convertedCost: valueToNumber(row.totalShipmentCost ?? row.TotalShipmentCost),
        convertedCurrencyCode: row.currencyCode ?? row.CurrencyCode,
        createdOn: moment(getLocalDateTime()),
        currencyCode: row.currencyCode ?? row.CurrencyCode,
        directPoint: row.directPoint ?? row.DirectPoint,
        effectiveTo: convertDateToMoment(row.pricingEffectiveTo ?? row.PricingEffectiveTo),
        equipmentTypeDetail: row.trailerDescription ?? row.TrailerDescription,
        error_message: row.errorMessage ?? row.ErrorMessage,
        flagStandardTranit: '',
        freightAccessorialCollection: accessorialsList,
        isRateEntry: null,
        LaneKey: row.laneKey ?? row.LaneKey,
        mileage: row.mileageMiles ?? row.MileageMiles,
        mileageKm: row.mileageKilometers ?? row.MileageKilometers,
        pricingBasis: isAPIRateShop ? 'API' : (row.pricingBasis ?? row.PricingBasis),
        pricingDetailKey: row.pricingKey ?? row.PricingKey,
        pricingType: row.pricingType ?? row.PricingType,
        RatedCurrencyCode: row.ratedCurrencyCode ?? row.RatedCurrencyCode,
        RatedTransportProviderCharge: row.ratedTransportProviderCharge ?? row.RatedTransportProviderCharge,
        rateShopKey: '',
        rateType: '',
        serviceDesc: row.serviceDescription ?? row.ServiceDescription,
        serviceKey: row.serviceKey ?? row.ServiceKey,
        serviceType: row.serviceCode ?? row.ServiceCode,
        shipmentCost: row.shipmentCost ?? row.ShipmentCost,
        spotQuoteNumber: row.spotQuoteContractNumber ?? row.SpotQuoteContractNumber,
        standardDaysTransit: row.standardDaysTransit ?? row.StandardDaysTransit,
        TariffKey: row.tariffKey ?? row.TariffKey,
        tariffDetailKey: row.tariffDetailKey ?? row.TariffDetailKey,
        totalShipmentCost: valueToNumber(row.totalShipmentCost ?? row.TotalShipmentCost),
        trailerDesc: row.trailerDescription ?? row.TrailerDescription,
        trailerkey: row.trailerKey ?? row.TrailerKey,
        viewCargoType: null,
      };
    });
  }
  data = data.filter(({ totalShipmentCost }) => {
    return Number(totalShipmentCost) > 0;
  });
  data = orderBy(data, ['totalShipmentCost'], ['asc']);
  return data;
};

export const prmShipmentTransportation = (data, userID, customerKey) => {
  const newData = [];

  data?.forEach(({ stopType, portRecKey, ...row }) => {
    const params =
      Number(stopType) === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
        ? {
            actualDate: 'prmCarrierActualShipDate',
            appointmentDate: 'prmCarrierAppontmentShipDate',
            key: 'originKey',
            requestedDate: 'prmShipperRequestedShipDate',
          }
        : {
            actualDate: 'prmCarrierActualDeliveryDate',
            appointmentDate: 'prmCarrierAppontmentDeliveryDate',
            key: 'destinationKey',
            requestedDate: 'prmShipperRequestedDeliveryDate',
          };
    newData.push({
      [params.requestedDate]: formatDate(
        convertLocalToUTC(dateTimeToSingleValue(row.requestedDate, row.requestedTime)),
        ISO_DATETIME_NO_TZ_FORMAT,
      ),
      [params.appointmentDate]: formatDate(
        convertLocalToUTC(dateTimeToSingleValue(row.appointmentDate, row.appointmentTime)),
        ISO_DATETIME_NO_TZ_FORMAT,
      ),
      [params.actualDate]: getFormattedTimeString(
        convertLocalToEST(dateTimeToSingleValue(row.actualDate, row.actualTime)),
      ),
      addr1: valueToString(row.address1),
      addr2: valueToString(row.address2),
      city: valueToString(row.city),
      countryCode: valueToString(row.countryCode),
      customerKey: valueToNumber(customerKey),
      isChangeLocationDetails: valueToNumber(row.isChangeLocationDetails),
      isModifiedDateTime: valueToNumber(row.isModifiedDateTime),
      name: valueToString(row.name),
      prmAppointmentType: valueToString(row.appointmentType),
      prmContactEmail: valueToString(row.contactEmail),
      prmContactName: valueToString(row.contactName),
      prmDisplaySequence: valueToNumber(nullToValue(row.displaySequence)),
      prmDockNumber: valueToString(row.dockNumber),
      prmDoorDockID: valueToString(row.doorDockID),
      prmExtension: valueToString(row.extension),
      prmHoursOfOperation: `${valueToString(
        row.fromOperationDay,
      )} TO ${valueToString(row.toOperationDay)} | ${convertOperationHoursTime(
        row.fromOperationHours,
      )} TO ${convertOperationHoursTime(row.toOperationHours)}`,
      prmLegMiles: valueToNumber(row.legMiles),
      prmLegNumber: valueToNumber(row.legNumber),
      prmModifiedBy: nullToValue(userID),
      prmOperation: valueToNumber(nullToValue(row.gridOperation)),
      prmPhone: valueToString(row.phone),
      prmPickupDeliveryID: valueToString(row.appointmentNo),
      prmPortRecKey: nullToValue(valueToNumber(portRecKey)),
      prmPortType: valueToString(row.portType),
      prmSequence: valueToNumber(nullToValue(row.displaySequence)),
      prmShipperConsigneeKey: nullToValue(valueToNumber(row.primaryKey)),
      prmStopType: valueToString(stopType),
      prmTaxId: valueToString(row.taxId),
      prmUom: valueToString(row.uom),
      searchId: valueToString(row.searchId),
      state: valueToString(row.stateCode),
      trailerNumber: valueToString(row.trailerNumber),
      zip: valueToString(row.zipCode),
      ...(Number(stopType) === SHIPMENT_TRANSPORTATION_TYPES[SHIPMENT_TRANSPORTATION_OBJECTS.PICKUP]
        ? {
            shipperLocationId: row.shipperLocationId || '',
          }
        : { consigneeLocationId: row.consigneeLocationId || '' }),
    });
  });
  return newData;
};

export const prmShipmentAdditionalDetails = (data, isMaster) => {
  return {
    accountNumber: data.accountNumber,
    bolNumber: data.bolNumber,
    branchKey: data.branchKey,
    cargoType: valueToString(data.cargoType),
    currencyCode: data.currencyCode,
    customerContact: valueToString(data.customerContact),
    customerKey: data.customerKey,
    fobCode: data.fobCode,
    freightAllowance: data.freightAllowance,
    incoCode: valueToString(data.incoCode)?.trim(),
    incoPoint: data.incoPoint,
    lspStationCode: data.lspStationCode,
    masterBolNumber: data.masterBolNumber,
    masterShipment: data?.masterShipment ? 1 : 0,
    modifiedBy: data.userId,
    nlccApproverUserId: data.nlccApproverUserId,
    nlccRequestorEmail: data.nlccRequestorEmail,
    paidAmount: valueToNumber(data.paidAmount),
    paymentTerms: valueToString(data.paymentTerms),
    poNumber: valueToString(data.purchaseOrderNumber),
    projectNo: '',
    proNo: data.proNo,
    rateShopCost: valueToNumber(isMaster ? data.rateShopCost : data.shipmentCost),
    rateShopKey: 0,
    rateType: data.status,
    serviceType: data.serviceType,
    shipmentKey: data.shipmentKey,
    shipmentTerms: data.shipmentTerms,
    shipmentType: data.shipmentType,
    soNumber: valueToString(data.salesOrderNumber),
    trailerId: valueToNumber(data.trailerKey),
    trailerNumber: data.trailerNumber,
    transportationPO: data.transportationPO,
  };
};

export const prmShipmentProductDetails = (data) => {
  const nextItemSequence = maxBy(data, (o) => o.itemSequenceKey)?.itemSequenceKey;
  return data.map((row) => ({
    accessorialData: Number(row.accessorialData?.qty)
      ? {
          qty: Number(row.accessorialData.qty),
          uom: row.accessorialData.uom ?? null,
        }
      : null,
    actualWeight: valueToNumber(row.actualWeight),
    billQty: valueToNumber(row.billQty),
    billQtyUom: valueToString(row.billQtyUom),
    book: valueToNumber(row.book),
    bookOks: valueToNumber(row.bookOks),
    cartonQty: valueToNumber(row.cartonQty),
    cartonUOM: valueToString(row.cartonUOM),
    class: valueToString(row.class),
    countryOfOrigin: valueToString(row.countryOfOrigin),
    crateNo: valueToString(row.crateNo),
    cube: valueToNumber(valueToNull(row.cube)),
    deliveryID: valueToString(row.deliveryID),
    dimUom: valueToString(row.dimUom),
    eccn: valueToString(row.eccn),
    hazmat: valueToString(row.hazmat),
    hazmatUnNo: valueToString(row.hazmatUnNo),
    height: valueToNumber(row.height),
    hts: valueToString(row.hts),
    itemSequenceKey: row.gridOperation === 1 ? nextItemSequence + 1 : row?.itemSequenceKey,
    length: valueToNumber(row.length),
    misc: valueToNumber(row.misc),
    miscOKs: valueToNumber(row.miscOKs),
    modifedBy: 0,
    nmfcNumber: valueToString(row.nmfcNumber),
    operation: valueToNumber(row.gridOperation),
    palletLoadType: valueToString(row.palletLoadType),
    poNumber: valueToString(row.poNumber),
    productCode: valueToString(row.productCode),
    productDescription: valueToString(row.productDescription),
    quantity: valueToNumber(row.quantity),
    reference1: valueToString(row.reference1),
    shipmentDetailsID: valueToNumber(row.shipmentDetailsID),
    soft: valueToNumber(row.soft),
    softOks: valueToNumber(row.softOks),
    soNumber: valueToString(row.soNumber),
    stcDescription: valueToString(row.stcDescription),
    unitMeasure: valueToString(row.unitMeasure),
    unitPrice: valueToNumber(row.unitPrice),
    weight: valueToNumber(row.weight),
    weightUom: valueToString(row.weightUom),
    width: valueToNumber(row.width),
  }));
};

export const prmShipmentProductDetailsSingle = (data) => ({
  accessorialData: Number(data.accessorialData?.qty)
    ? {
        qty: Number(data.accessorialData.qty),
        uom: data.accessorialData.uom ?? null,
      }
    : null,
  actualWeight: valueToNumber(data.actualWeight),
  billQty: valueToNumber(data.billQty),
  billQtyUom: valueToString(data.billQtyUom),
  book: valueToNumber(data.book),
  bookOks: valueToNumber(data.bookOks),
  cartonQty: valueToNumber(data.cartonQty),
  cartonUOM: valueToString(data.cartonUOM),
  class: valueToString(data.class),
  countryOfOrigin: valueToString(data.countryOfOrigin),
  crateNo: valueToString(data.crateNo),
  cube: valueToNumber(valueToNull(data.cube)),
  deliveryID: valueToString(data.deliveryID),
  dimUom: valueToString(data.dimUom),
  eccn: valueToString(data.eccn),
  hazmat: valueToString(data.hazmat),
  hazmatUnNo: valueToString(data.hazmatUnNo),
  height: valueToNumber(data.height),
  hts: valueToString(data.hts),
  itemSequenceKey: data.gridOperation === 1 ? 0 : data?.itemSequenceKey,
  length: valueToNumber(data.length),
  misc: valueToNumber(data.misc),
  miscOKs: valueToNumber(data.miscOKs),
  modifedBy: 0,
  nmfcNumber: valueToString(data.nmfcNumber),
  operation: valueToNumber(data.gridOperation),
  palletLoadType: valueToString(data.palletLoadType),
  palletPackageType: valueToString(data.palletPackageType),
  poNumber: valueToString(data.poNumber),
  productCode: valueToString(data.productCode),
  productDescription: valueToString(data.productDescription),
  quantity: valueToNumber(data.quantity),
  reference1: valueToString(data.reference1),
  shipmentDetailsID: valueToNumber(data.shipmentDetailsID),
  soft: valueToNumber(data.soft),
  softOks: valueToNumber(data.softOks),
  soNumber: valueToString(data.soNumber),
  stcDescription: valueToString(data.stcDescription),
  unitMeasure: valueToString(data.unitMeasure),
  unitPrice: valueToNumber(data.unitPrice),
  weight: valueToNumber(data.weight),
  weightUom: valueToString(data.weightUom),
  width: valueToNumber(data.width),
});

export const prmShipmentBillingDetails = (data) => {
  return {
    address1: valueToString(data?.address1),
    address2: valueToString(data?.address2 ? data?.address2 : ''),
    city: valueToString(data?.city),
    contact: valueToString(data?.contact),
    contactEmail: valueToString(data?.contactEmail),
    countryCode: valueToString(data?.countryCode),
    modifiedBy: data.userId,
    name: valueToString(data?.name),
    postalCode: valueToString(data?.postalCode),
    shipmentKey: data.shipmentKey,
    stateCode: valueToString(data?.stateCode),
    vatNumber: valueToString(data?.vatNumber),
  };
};

export const prmShipmentVendorDetails = (data, shipmentKey, userId) => {
  return data.map((row) => ({
    city: valueToString(row.city),
    countryCode: valueToString(row.countryCode),
    id: valueToNumber(row.id),
    modifiedBy: userId,
    operation: valueToNumber(row.gridOperation),
    postalCode: valueToString(row.postalCode),
    shipmentKey: valueToNumber(shipmentKey),
    stateCode: valueToString(row.stateCode),
    vendorEmail: valueToString(row.vendorEmail),
    vendorKey: valueToNumber(row.vendorKey),
    vendorName: valueToString(row.vendorName),
    vendorPhoneNumber: valueToString(row.vendorPhone),
  }));
};

export const prmShipmentCategory = (data, userId) => {
  return data.map((row, index) => ({
    hierDetSequence: valueToNumber(index + 1),
    hierLookupDetKey: valueToNumber(nullToValue(row.hierLookupDetKey)),
    hierLookupDetKeyParent: valueToNumber(nullToValue(row.hierLookupDetKeyParent)),
    modifiedBy: userId,
  }));
};

export const shipmentSpotBidDataToLocal = (data) => {
  return data.map((row) => ({
    ...row,
    convertedCost: row.cost,
    createdOn: convertDateESTToUTCToUserLocal(row.createdOn),
    effectiveTo: row.bidExpiryTime,
    standardDaysTransit: row.standardTransitDays,
    userCreatedBy: row.createdByName,
  }));
};

export const shipmentTrackApiToLocal = (data) => {
  if (data?.length > 0) {
    return trimObjectValues(
      data.map((row) => ({
        ...row,
        carrierDeliveryDate: convertDateStringtoMoment(row.carrierDeliveryDate),
        carrierDeliveryTime: convertDateStringtoMoment(row.carrierDeliveryDate),
        carrierShipDate: convertDateStringtoMoment(row.carrierShipDate),
        carrierShipTime: convertDateStringtoMoment(row.carrierShipDate),
        dateTimeAtStatusDate: convertDateStringtoMoment(row.dateTimeAtStatus),
        dateTimeAtStatusTime: convertDateStringtoMoment(row.dateTimeAtStatus),
        dateTimeStamp: convertDateStringtoMoment(row.dateTimeStamp),
        shipperRequestedDeliveryDate: convertDateToMoment(row.shipperRequestedDeliveryDate, 'M/D/YYYY hh:mm:ss A'),
        shipperRequestedShipDate: convertDateToMoment(row.shipperRequestedShipDate, 'M/D/YYYY hh:mm:ss A'),
      })),
    );
  }
  return [];
};

export const convertShipmentRackingLocalToAPI = (data) => {
  const carrierShipDate = combineDateTimeMoment(data?.carrierShipDate, data?.carrierShipTime);
  const dateTimeAtStatus = combineDateTimeMoment(data?.dateTimeAtStatusDate, data?.dateTimeAtStatusTime);

  return {
    carrierDeliveryDate: combineDateTimeMoment(data?.carrierDeliveryDate, data?.carrierDeliveryTime)?.toJSON(),
    carrierShipDate: carrierShipDate?.toJSON(),
    dateTimeAtStatus: dateTimeAtStatus?.toJSON(),
    dateTimeStamp: data?.dateTimeStamp?.toJSON(),
    delivaryTime: formateWithMoment(data?.carrierDeliveryDate, 'hh:mm A'),
    entryDateTime: null,
    eventLocalTime: formateWithMoment(data?.dateTimeAtStatus, 'hh:mm A'),
    exceptionTypeCode: valueToString(data?.exceptionTypeCode),
    iCity: valueToString(data?.iCity),
    iCountryCode: valueToString(data?.iCountryCode),
    iStateCode: valueToString(data?.iStateCode),
    shipmentNumber: valueToString(data?.shipmentNumber),
    shipmentTrackKey: valueToNumber(data?.shipmentTrackKey),
    shipTime: formateWithMoment(data?.shipperRequestedShipDate, 'hh:mm A'),
    signature: valueToString(data?.signature),
    statusCode: valueToString(data?.statusCode),
    statusTypeCode: valueToString(data?.statusTypeCode),
    timeAtStatus: dateTimeAtStatus?.format('M/D/YYYY hh:mm:ss A'),
    timeZone: valueToString(moment.tz(getLocalTimeZone()).format('z')),
    trackSequenceKey: null,
    userCreatedBy: valueToNumber(data?.userCreatedBy),
  };
};

export const convertRateShopResponseToAPI = (data, customerKey, selectedCarrierKey) => {
  if (data?.length > 0) {
    return data.map((row) => ({
      accessorials: (row.accessorials || [])
        .map(
          ({
            auditedChargeAmount,
            description,
            accessorialCode,
            costType,
            cost,
            costName,
            CurrencyExchangeCode,
            CurrencyExchangeRate,
            AccessorialKey,
            AccessorialDetailKey,
          }) => ({
            AccessorialDetailKey,
            AccessorialKey,
            accessorialCode: accessorialCode ? accessorialCode : costType,
            auditedChargeAmount: valueToNumber(auditedChargeAmount ? auditedChargeAmount : cost),
            CurrencyExchangeCode,
            CurrencyExchangeRate,
            description: description ? description : costName,
          }),
        )
        .filter(({ accessorialCode }) => accessorialCode !== 'FREIGHT'),
      CurrencyConversion: row.CurrencyConversion,
      CurrencyExchangeCode: row.CurrencyExchangeCode,
      CurrencyExchangeRate: row.CurrencyExchangeRate,
      CustomerNotes: row.CustomerNotes,
      cargoType: row.cargoType,
      carrierKey: row.carrierKey,
      carrierName: row.carrierName,
      currencyCode: row.currencyCode,
      customerKey,
      directPoint: row.directPoint,
      isSelected: selectedCarrierKey === row?.carrierKey ? 1 : 0,
      LaneKey: row.LaneKey,
      mileageKilometers: row.mileageKm,
      mileageMiles: row.mileage,
      pricingBasis: row.pricingBasis,
      pricingKey: row.pricingDetailKey,
      pricingType: row.pricingType,
      RatedCurrencyCode: row.RatedCurrencyCode,
      RatedTransportProviderCharge: row.RatedTransportProviderCharge,
      serviceKey: row.serviceKey,
      standardDaysTransit: row.standardDaysTransit,
      tariffDetailKey: row.tariffDetailKey,
      tariffKey: valueToNumber(row.TariffKey),
      totalAccessorialCharge: row.accessorialCost,
      totalShipmentCost: row.totalShipmentCost ? row.totalShipmentCost : row.shipmentCost,
      trailerDescription: row.trailerDesc,
      trailerKey: valueToNumber(row.trailerkey) ? valueToNumber(row.trailerkey) : -1,
    }));
  }
};

export const parseCreateQuoteDataFromFormData = (data) => {
  return {
    accessorialGridModel: data?.accessorials?.map((row) => ({
      accChargeAmount: valueToNumber(row?.accChargeAmount),
      accChargeType: valueToString(row?.codeId),
      codeDesc: valueToString(row?.codeDesc),
      isChecked: row?.isChecked ? 1 : 0,
    })),
    branch: valueToString(data?.branch),
    cargoType: data.cargoType,
    createdBy: valueToNumber(data?.createdBy),
    createdOn: formateWithMoment(data?.createdOn, 'MM/D/yyyy'),
    currencyCode: valueToString(data?.currencyCode),
    customerKey: valueToNumber(data?.customerKey),
    deliveryDate: data.deliveryDate === '' ? null : convertUserLocalToEST(data.deliveryDate),
    modifiedBy: valueToString(data?.modifiedBy),
    modifiedOn: formateWithMoment(data?.modifiedOn, 'MM/D/yyyy'),
    productGridModel: data?.products?.map((row) => ({
      billQty: valueToString(row?.billQty),
      billQtyUom: valueToString(row?.billQtyUom),
      billQtyUomName: valueToString(row?.billQtyUomName),
      class: valueToString(row?.class),
      className: valueToString(row?.className),
      createdBy: valueToNumber(row?.createdBy),
      cube: valueToNumber(row?.cube),
      dimUom: valueToString(row?.dimUom),
      dimUomName: valueToString(row?.dimUomName),
      gridOperation: valueToNumber(row?.gridOperation),
      height: valueToNumber(row?.height),
      itemSequenceKey: valueToNumber(row?.itemSequenceKey),
      length: valueToNumber(row?.length),
      palletLoadType: 'Non Stackable', // Always use this static
      weight: valueToNumber(row?.weight),
      weightUom: valueToString(row?.weightUom),
      weightUomName: valueToString(row?.weightUomName),
      width: valueToNumber(row?.width),
    })),
    projectNo: valueToString(data?.projectNo),
    quoteNo: valueToString(data?.quoteNo),
    rateShopCost: valueToNumber(data?.rateShopCost),
    rateShopKey: 0,
    shipDate: convertUserLocalToEST(data?.shipDate),
    shipmentDocumentInformation: convertDocumentsLocalToApiForAddShipment(data?.documents),
    shipmentKey: valueToNumber(data?.shipmentKey),
    shipmentNote: data?.shipmentNote,
    shipmentNumber: valueToString(data?.shipmentNumber),
    shipmentStatus: data?.shipmentStatus,
    shipmentTerms: valueToString(data?.shipmentTerms),
    shipmentType: valueToString(data?.shipmentType),
    transportGridModel: data?.stops?.map((row) => ({
      city: valueToString(row?.city),
      countryCode: valueToString(row?.countryCode),
      gridOperation: valueToNumber(row?.gridOperation),
      oldStopSequence: valueToNumber(row?.oldStopSequence),
      portRecKey: valueToString(row?.portRecKey),
      portType: valueToString(row?.portType),
      postalCode: valueToString(row?.postalCode),
      state: valueToString(row?.state),
      stopSequence: valueToNumber(row?.stopSequence),
      stopTypeID: valueToString(row?.stopTypeID),
    })),
  };
};

export const parseQuoteDataToRateEngine = (data) => {
  let shipmentOrigin = data?.transportGridModel?.filter(({ stopTypeID }) => stopTypeID === '1');
  shipmentOrigin = shipmentOrigin?.[0];
  let shipmentDestination = data?.transportGridModel?.filter(({ stopTypeID }) => stopTypeID === '2');
  shipmentDestination = shipmentDestination?.[shipmentDestination?.length - 1];

  const totalNumberOfPieces = sumBy(data?.productGridModel || [], ({ billQty }) => valueToNumber(billQty));

  const totalWeight = sumBy(data?.productGridModel || [], ({ weight }) => valueToNumber(weight));

  const totalClass = maxBy(data?.productGridModel, ({ class: classValue }) => valueToNumber(classValue))?.class;

  const formData = {
    RateShopCriteria: {
      Accessorials: data?.accessorials
        ? data?.accessorials.map((row) => ({
            AccessorialCode: row.accChargeType?.trim(),
            BilledAmount: 0,
            CurrencyCode: null,
            Description: row.codeDesc,
          }))
        : [],
      AccountNumber: null,
      AuditType: null,
      BranchKey: data?.branch,
      CargoType: data.cargoType?.length ? data.cargoType.join(',') : '**',
      CarrierKey: '-1',
      CODValue: 0,
      ContractNumber: null,
      CriteriaId: 1,
      Cube: 0,
      CurrencyCode: data.currencyCode,
      CustomerKey: data?.customerKey,
      Debug: false,
      DeclaredValue: 0,
      DeliveryDate: `/Date(${moment(data?.deliveryDate ? data?.deliveryDate : data?.shipDate).valueOf()})/`,
      Details: data?.productGridModel
        ?.filter(({ weight }) => weight > 0)
        .map((product, index) => ({
          ActualWeight: 0,
          BilledQuantity: valueToNumber(product.billQty),
          BilledWeight: valueToNumber(product.weight),
          BilledWeightUOM: null,
          Cube: 0,
          CubeUOM: null,
          Height: valueToNumber(product.height),
          Length: valueToNumber(product.length),
          MeasurementType: valueToString(product.weightUom),
          NumberOfPieces: valueToNumber(product.billQty),
          ProductCode: '',
          RatingClass: valueToString(product.class),
          SequenceNumber: valueToNumber(index + 1),
          TrailerKey: 0,
          Width: valueToNumber(product.width),
        })),
      DGIndicator: data?.DGIndicator,
      DiscountMode: valueToString(data?.shipmentType),
      FreightChargeBilled: 0,
      Height: valueToNumber(sumBy(data?.productGridModel || [], ({ height }) => Number(height))),
      IntercompanyType: valueToString(data?.shipmentTerms),
      IsShipmentRateshop: 'Y',
      ItemLevelRating: false,
      Lanes: [
        {
          Destination: {
            Address1: valueToString(shipmentDestination?.address1),
            Address2: null,
            BranchKey: -1,
            City: shipmentDestination?.city,
            CountryCode: shipmentDestination?.countryCode,
            Key: valueToNumber(shipmentDestination?.primaryKey),
            Port: {
              Code: stringToNull(shipmentDestination?.portCode),
              Key: valueToNumber(shipmentDestination?.portRecKey),
              Type: stringToNull(shipmentDestination?.portType),
            },
            Postal: shipmentDestination?.postalCode,
            PostalTo: null,
            StateCode: shipmentDestination?.state,
          },
          Id: 1,
          LaneKey: 0,
          MileageMile: 0,
          Origin: {
            Address1: valueToString(shipmentOrigin?.address1),
            Address2: null,
            BranchKey: -1,
            City: shipmentOrigin?.city,
            CountryCode: shipmentOrigin?.countryCode,
            Key: valueToNumber(shipmentOrigin?.primaryKey),
            Port: {
              Code: stringToNull(shipmentOrigin?.portCode),
              Key: valueToNumber(shipmentOrigin?.portRecKey),
              Type: stringToNull(shipmentOrigin?.portType),
            },
            Postal: shipmentOrigin?.postalCode,
            PostalTo: null,
            StateCode: shipmentOrigin?.state,
          },
        },
      ],
      LDMValue: 0,
      Length: valueToNumber(sumBy(data?.productGridModel || [], ({ length }) => Number(length))),
      LinerCode: null,
      LinerType: null,
      MileageKilometer: 0,
      MileageMile: 0,
      NumberOfPieces: totalNumberOfPieces,
      PackageBranchKeys: '-1',
      PricingBasis: '**',
      PricingType: 'PACT',
      ProductCode: null,
      RatingClass: valueToString(totalClass),
      ServiceCode: '**',
      ServiceDescription: '',
      ServiceKey: -1,
      ShipmentDate: data?.shipDate ? `/Date(${moment(data?.shipDate).valueOf()})/` : null,
      ShipmentTerms: valueToString(data?.shipmentTerms),
      Source: 'RateShop',
      Stops:
        data?.transportGridModel?.length > 2
          ? data?.transportGridModel?.map((row, index) => ({
              ActualCity: valueToString(row.city),
              ActualState: valueToString(row.state),
              LaneId: 1,
              LegMiles: 0,
              Location: {
                Address1: valueToString(row.address1),
                Address2: valueToString(row.address2),
                BranchKey: -1,
                City: valueToString(row.city),
                CountryCode: valueToString(row.countryCode),
                Key: 0,
                Port: {
                  Code: stringToNull(row?.portCode),
                  Key: valueToNumber(row?.portRecKey),
                  Type: stringToNull(row?.portType),
                },
                Postal: valueToString(row.postalCode),
                PostalTo: null,
                StateCode: valueToString(row.state),
              },
              Mileage: 0,
              NumberPieces: totalNumberOfPieces,
              Sequence: valueToNumber(index + 1),
              ShipRecKey: 0,
              TotalCharge: 0,
              TripMiles: 0,
              Type: null,
              Weight: totalWeight,
            }))
          : [],
      TaxableValue: 0,
      Taxes: [],
      TimeFrame: 'C',
      TotalAccessorialBilled: 0,
      TrailerKey: -1,
      TransportationMode: '**',
      Weight: valueToNumber(sumBy(data?.productGridModel || [], ({ weight }) => Number(weight))),
      WeightUnitOfMeasure: data?.productGridModel?.[0]?.weightUom,
      Width: valueToNumber(sumBy(data?.productGridModel || [], ({ width }) => Number(width))),
    },
  };
  return formData;
};

const deriveDGIndicator = (productList) => {
  const deriveDGIndicatorFromHazmat = (hazmat) => {
    const hazmatNormalized = hazmat ? hazmat.toLowerCase() : hazmat;
    if (hazmatNormalized === 'y' || hazmatNormalized === 'yes') {
      return 'Y';
    }
    if (hazmatNormalized === 'n' || hazmatNormalized === 'no') {
      return 'N';
    }
    return '-1';
  };

  if (productList && Array.isArray(productList) && productList.length > 0) {
    const isShipmentEdit = Boolean(productList[0].shipmentNo);
    const sortedProductList = productList.toSorted(
      isShipmentEdit ? (a, b) => a.itemSequenceKey - b.itemSequenceKey : (a, b) => a.index - b.index,
    );
    const topLineProductListHazmat = sortedProductList[0].hazmat;
    return deriveDGIndicatorFromHazmat(topLineProductListHazmat);
  }

  return '-1';
};

export const shipmentRateShopLocalToRateEngineAPI = (
  Accessorials,
  shipmentDetails,
  filterData,
  currencyCode,
  isAPIRateShop,
) => {
  shipmentDetails.transportationList = orderBy(shipmentDetails.transportationList, ['displaySequence'], ['asc']);
  const shipmentOrigin = shipmentDetails.transportationList[0];
  const shipmentDestination = shipmentDetails.transportationList[shipmentDetails.transportationList.length - 1];

  const originList = shipmentDetails.transportationList?.filter(({ stopType }) => stopType === '1');

  const destList = shipmentDetails.transportationList?.filter(({ stopType }) => stopType === '2');

  const getValuesFromMoment = (_value, type) => {
    let value = _value;
    if (typeof value === 'string') {
      value = moment(value);
    }
    return value?.get(type);
  };

  let shipmentDate = moment(originList[0].requestedDate);
  let deliveryDate = moment(destList[destList.length - 1].requestedDate);

  shipmentDate = shipmentDate?.set({
    hour: getValuesFromMoment(originList?.[0]?.requestedTime, 'hour'),
    millisecond: 0,
    minute: getValuesFromMoment(originList?.[0]?.requestedTime, 'minute'),
    second: 0,
  });

  if (destList?.[destList.length - 1]?.requestedTime && deliveryDate) {
    deliveryDate = deliveryDate?.set({
      hour: getValuesFromMoment(destList?.[destList.length - 1]?.requestedTime, 'hour'),
      millisecond: 0,
      minute: getValuesFromMoment(destList?.[destList.length - 1]?.requestedTime, 'minute'),
      second: 0,
    });
  }

  shipmentDetails.shipmentDate = shipmentDate;
  shipmentDetails.deliveryDate = deliveryDate;

  const DGIndicator = deriveDGIndicator(shipmentDetails.productList);

  let stops = shipmentDetails?.transportationList;
  if (stops.length === 2) {
    stops = [];
  }

  let mainData = {};
  const formData = {
    Accessorials,
    AccountNumber: valueToString(shipmentDetails?.accountNumber),
    AuditType: null,
    BranchKey: shipmentDetails.branchKey,
    CargoType: getRateShopStringAll(filterData.cargoType),
    CarrierKey: filterData.requiredCarrierKey ? filterData.requiredCarrierKey : '-1',
    CODValue: 0,
    ContractNumber: null,
    CriteriaId: 1,
    Cube: valueToNumber(shipmentDetails.totalCube),
    CurrencyCode: currencyCode,
    CustomerKey: shipmentDetails.customerKey,
    Debug: false,
    DeclaredValue: 0,
    DeliveryDate: `/Date(${moment(
      shipmentDetails.deliveryDate ? shipmentDetails.deliveryDate : shipmentDetails.shipmentDate,
    ).valueOf()})/`,
    Details: shipmentDetails?.productList
      ?.filter(({ weight, accessorialData }) => weight > 0 || accessorialData?.qty > 0)
      .map((product, index) => ({
        AccessorialUnitQty: product.accessorialData?.qty || null,
        ActualWeight: !isAPIRateShop ? 0 : valueToNumber(product.weight),
        BilledQuantity: valueToNumber(product.billQty),
        BilledWeight: valueToNumber(product.weight),
        BilledWeightUOM: product.weightUom,
        Cube: valueToNumber(product.cube),
        Height: valueToNumber(product.height),
        Length: valueToNumber(product.length),
        MeasurementType: product.weightUom,
        NumberOfPieces: valueToNumber(product.quantity),
        RatingClass: String(product.class),
        SequenceNumber: valueToNumber(index + 1),
        Width: valueToNumber(product.width),
      })),
    DGIndicator,
    DiscountMode: valueToString(shipmentDetails.shipmentType),
    FreightChargeBilled: 0,

    havingLeastCost: filterData.carrierRequirements === SHIPMENT_RATE_SHOP_RATTING_PREFERENCES.LEAST_COST, // Internal purpose

    IntercompanyType: valueToString(shipmentDetails.shipmentTerms),
    IsShipmentRateshop: 'Y',
    ItemLevelRating: false,
    Lanes: [
      {
        Destination: {
          Address1: shipmentDestination.address1,
          Address2: null,
          BranchKey: valueToNumber(shipmentDetails.branchKey),
          City: shipmentDestination.city,
          CountryCode: shipmentDestination.countryCode,
          Key: shipmentDestination.primaryKey,
          Port: {
            Code: stringToNull(shipmentDestination.portCode),
            Key: valueToNumber(shipmentDestination.portRecKey),
            Type: stringToNull(shipmentDestination.portType),
          },
          Postal: shipmentDestination.zipCode,
          PostalTo: null,
          StateCode: shipmentDestination.stateCode,
        },
        Id: 1,
        LaneKey: 0,
        MileageMile: 0,
        Origin: {
          Address1: shipmentOrigin.address1,
          Address2: null,
          BranchKey: valueToNumber(shipmentDetails.branchKey),
          City: shipmentOrigin.city,
          CountryCode: shipmentOrigin.countryCode,
          Key: valueToNumber(shipmentOrigin.primaryKey),
          Port: {
            Code: stringToNull(shipmentOrigin.portCode),
            Key: valueToNumber(shipmentOrigin.portRecKey),
            Type: stringToNull(shipmentOrigin.portType),
          },
          Postal: shipmentOrigin.zipCode,
          PostalTo: null,
          StateCode: shipmentOrigin.stateCode,
        },
      },
    ],
    LDMValue: 0,
    LinerCode: null,
    LinerType: null,
    MileageKilometer: shipmentDetails.totalMileage,
    MileageMile: shipmentDetails.totalMileage,
    PackageBranchKeys: '-1',
    PricingBasis: getRateShopStringAll(shipmentDetails.pricingBasis),
    PricingType: 'PACT',
    ProductCode: null,
    ServiceCode: '**',
    ServiceKey: filterData.serviceKey ? valueToNumber(filterData.serviceKey) : -1,
    ShipmentDate: shipmentDetails.shipmentDate ? `/Date(${moment(shipmentDetails.shipmentDate).valueOf()})/` : null,
    ShipmentTerms: shipmentDetails.shipmentTerms,
    Source: 'ShipmentRateShop',
    Stops: stops.map((row, index) => ({
      LaneId: 1,
      Location: {
        Address1: valueToString(row.address1),
        Address2: valueToString(row.address2),
        BranchKey: valueToNumber(shipmentDetails.branchKey),
        City: valueToString(row.city),
        CountryCode: valueToString(row.countryCode),
        Key: valueToNumber(row.primaryKey),
        Port: {
          Code: row.portCode,
          Key: valueToNumber(row.portRecKey),
          Type: row.portType,
        },
        Postal: valueToString(row.zipCode),
        PostalTo: null,
        StateCode: valueToString(row.stateCode),
      },
      Sequence: index + 1,
      ShipRecKey: valueToNumber(row.primaryKey),
      Type: null,
    })),
    TaxableValue: 0,
    Taxes: shipmentDetails?.taxes
      ? shipmentDetails?.taxes.map((row) => ({
          BilledAmount: valueToNumber(row?.taxAmount),
          Description: valueToString(row?.taxTypeDesc),
          TaxCode: valueToString(row.taxTypeCode),
        }))
      : [],
    TimeFrame: 'C',
    TotalAccessorialBilled: 0,
    TrailerKey: filterData.trailerKey ? filterData.trailerKey : -1,
    TransportationMode: '**',
    Weight: valueToNumber(shipmentDetails.shipmentTotalWeight),
    WeightUnitOfMeasure: shipmentDetails.weightUOM,
  };

  if (isAPIRateShop) {
    mainData = {
      RateQuote: {
        AccountNos: '13823813,0680281,123456',
        CarrierKeys: '1107,58,16',
        CustomerKey: shipmentDetails.customerKey,
        nVision_request: {
          AccessToken: null,
          Action: null,
          ApplicationID: 0,
          AppsName: null,
          AuthenticationToken: null,
          ConnectionString: null,
          Debug: false,
          DNSIdentifier: null,
          EndPointAddress: null,
          ErrorMessage: null,
          LicenceKey: null,
          LoadOptions: null,
          LoginID: null,
          ModuleName: null,
          OwnerID: 0,
          Password: null,
          RateShopCriteria: formData,
          RequestId: null,
          ServiceExpiryDate: null,
          ServiceModuleID: 0,
          UserID: 0,
          UserName: null,
          Version: null,
        },
      },
    };
  } else {
    mainData = { RateShopCriteria: formData };
  }

  return mainData;
};

export const parseStopsForMilageByStops = (stops) => {
  return stops
    ? stops?.map((row) => ({
        Address1: null,
        Address2: null,
        City: row.city,
        Coords: null,
        CountryCode: row.countryCode,
        Postal: row.zipCode,
        StateCode: row.stateCode,
      }))
    : [];
};

export const convertRateShopUiToRateEngine = (data) => {
  return {
    RateShopCriteria: {
      Accessorials: data.accessorials.map(({ codeId, codeDesc }) => ({
        AccessorialCode: codeId,
        BilledAmount: 0,
        CurrencyCode: null,
        Description: codeDesc,
      })),
      AccountNumber: '',
      AuditType: null,
      BranchKey: valueToNumber(data.globalRateShopForm?.branchKey),
      CargoType: data.globalRateShopForm.cargoType ? data.globalRateShopForm.cargoType.join(',') : '**',
      CarrierKey: data.globalRateShopForm?.customerKey
        ? data.carriers.map(({ carrierKey }) => carrierKey).join(',')
        : '**',
      CODValue: valueToNumber(data.globalRateShopForm.CODValue),
      ContractNumber: null,
      CriteriaId: 1,
      Cube: sumBy(data.items || [], ({ cube }) => cube),
      CurrencyCode: data.globalRateShopForm.currencyCode ? valueToString(data.globalRateShopForm.currencyCode) : '**',
      CustomerKey: valueToNumber(data.globalRateShopForm?.customerKey),
      Debug: false,
      DeclaredValue: valueToNumber(data.globalRateShopForm.declaredValue),
      DeliveryDate: data.globalRateShopForm.deliveryDate
        ? `/Date(${data.globalRateShopForm.deliveryDate.valueOf()})/`
        : null,
      Details: data.itemsForm.items.map((row, index) => ({
        AccessorialUnitQty: row.accessorialData?.qty || null,
        BilledQuantity: valueToNumber(row?.billQuantity),
        BilledWeight: valueToNumber(row?.billedWeight),
        BilledWeightUOM: valueToString(data.itemsForm.weightUom),
        Cube: valueToNumber(row?.cube),
        Height: valueToNumber(row?.height),
        Length: valueToNumber(row?.length),
        MeasurementType: valueToString(data.itemsForm.weightUom),
        NumberOfPieces: valueToNumber(row?.numberOfPieces),
        RatingClass: String(row?.class),
        SequenceNumber: index + 1,
        Width: valueToNumber(row?.width),
      })),
      DGIndicator: data.globalRateShopForm.DGIndicator,
      DiscountMode: valueToString(data.globalRateShopForm.shipmentType),
      FreightChargeBilled: 0,
      IntercompanyType: valueToString(data.globalRateShopForm.shipmentTerms),
      IsShipmentRateshop: 'N',
      ItemLevelRating: false,
      Lanes: data.lanes.map((row, index) => ({
        Destination: {
          Address1: null,
          Address2: null,
          City: valueToString(row.DEST_city),
          CountryCode: valueToString(row.DEST_countryCode),
          Key: 0,
          Port: {
            Code: row.DEST_portCode ? row.DEST_portCode : null,
            Key: row.DEST_portRecKey,
            Type: row.DEST_portType ? row.DEST_portType : null,
          },
          Postal: valueToString(row.DEST_postalCode),
          PostalTo: null,
          StateCode: valueToString(row.DEST_stateCode),
        },
        Id: index + 1,
        MileageMile: 0,
        Origin: {
          Address1: null,
          Address2: null,
          City: valueToString(row.ORIGIN_city),
          CountryCode: valueToString(row.ORIGIN_countryCode),
          Key: 0,
          Port: {
            Code: row.ORIGIN_portCode ? row.ORIGIN_portCode : null,
            Key: row.ORIGIN_portRecKey,
            Type: row.ORIGIN_portType ? row.ORIGIN_portType : null,
          },
          Postal: valueToString(row.ORIGIN_postalCode),
          PostalTo: null,
          StateCode: valueToString(row.ORIGIN_stateCode),
        },
      })),
      LDMValue: valueToNumber(data.globalRateShopForm.LDMValue),
      LinerCode: data.globalRateShopForm.LinerCode ? data.globalRateShopForm.LinerCode : null,
      LinerType: data.globalRateShopForm.LinerType ? data.globalRateShopForm.LinerType : null,
      MileageKilometer: 0,
      MileageMile: 0,
      PackageBranchKeys: '-1',
      PricingBasis: valueToString(data.globalRateShopForm.pricingBasis),
      PricingType: valueToString(data.globalRateShopForm.pricingType),
      ProductCode: valueToString(data.globalRateShopForm.productCode),
      ServiceCode: '**',
      ServiceKey: -1,
      ShipmentDate: data.globalRateShopForm.shipmentDate
        ? `/Date(${data.globalRateShopForm.shipmentDate.valueOf()})/`
        : null,
      ShipmentTerms: valueToString(data.globalRateShopForm.shipmentTerms),
      Source: 'RateShop',
      Stops: data.stops.map((row, index) => ({
        ActualCity: valueToString(row.city),
        ActualState: valueToString(row.stateCode),
        LaneId: row.laneId,
        LegMiles: valueToNumber(row.legMile),
        Location: {
          Address1: '',
          Address2: '',
          City: valueToString(row.city),
          CountryCode: valueToString(row.countryCode),
          Port: {
            Code: row.portCode ? row.portCode : null,
            Key: row.portCode ? 1 : 0,
            Type: row.portType ? row.portType : null,
          },
          Postal: valueToString(row.postalCode),
          PostalTo: null,
          StateCode: valueToString(row.stateCode),
        },
        Mileage: valueToNumber(row.legMile),
        NumberPieces: valueToNumber(row.numberOfPieces),
        Sequence: index + 1,
        ShipRecKey: 0,
        TripMiles: 0,
        Type: null,
        Weight: valueToNumber(row.weight),
      })),
      TaxableValue: 0,
      Taxes: data.taxes.map(({ codeId, codeDesc }) => ({
        BilledAmount: 0,
        CurrencyCode: data.globalRateShopForm?.currencyCode ? data.globalRateShopForm?.currencyCode : '**',
        Description: codeDesc,
        TaxCode: codeId,
      })),
      TimeFrame: valueToString(data.globalRateShopForm.timeFrame),
      TotalAccessorialBilled: 0,
      TrailerKey: data.globalRateShopForm.trailerKey ? valueToNumber(data.globalRateShopForm.trailerKey) : -1,
      TransportationMode: '**',
      Weight: sumBy(data.items || [], ({ billWeight }) => billWeight),
      WeightUnitOfMeasure: valueToString(data.globalRateShopForm.measurementUit),
    },
  };
};

export const convertRateEnginApiResponseToRateShopModule = (_data) => {
  let data = _data || [];
  if (data) {
    data = data.map((row) => {
      const tariffRateDate = convertDateToMoment(row.TariffRateDate);
      const pricingEffectiveFrom = convertDateToMoment(row.PricingEffectiveFrom);
      const pricingEffectiveTo = convertDateToMoment(row.PricingEffectiveTo);
      const tariffEffectiveFrom = convertDateToMoment(row.TariffEffectiveFrom);
      const tariffEffectiveTo = convertDateToMoment(row.TariffEffectiveTo);
      return {
        ABSMaximumUsed: row.ABSMaximumUsed,
        ABSMinimumUsed: row.ABSMinimumUsed,
        ABSTotalCharge: row.ABSTotalCharge,
        accessorialCost: sum(
          row.accessorials ? row.accessorials.map(({ AuditedChargeAmount }) => AuditedChargeAmount) : [],
        ),
        accessorials: row?.Accessorials
          ? row?.Accessorials?.map((accRow) => ({
              accessorialCode: accRow?.AccessorialCode,
              auditedChargeAmount: accRow?.AuditedChargeAmount,
              calculationType: accRow?.CalculationType,
              currencyCode: accRow?.CurrencyCode,
              description: accRow?.Description,
              discountAmount: accRow?.DiscountAmount,
              effectiveFromDate: formateWithMoment(accRow.EffectiveFromDate, 'DD-MMM-YYYY'),
              effectiveToDate: formateWithMoment(accRow.EffectiveToDate, 'DD-MMM-YYYY'),
              fuelChargeIndicator: accRow?.FuelChargeIndicator,
              note: accRow?.ErrorMessage,
            }))
          : [],
        accountNumber: row.AccountNumber,
        bidComment: row.ErrorMessage,
        branchDescription: row.BranchDescription,
        bureauMinimumUsed: row.BureauMinimumUsed,
        cargoType: row.CargoType,
        carrierKey: row.CarrierKey,
        carrierName: row.CarrierName,
        convertedCost: row.ConvertedCost,
        convertedCurrencyCode: row.ConvertedCurrency,
        createdOn: moment(getLocalDateTime()),
        currencyCode: row.CurrencyCode,
        deficitRate: row.DeficitRate,
        deficitWeight: row.DeficitWeight,
        directPoint: row.DirectPoint,
        discountPercentage: row.DiscountPercentage,
        effectiveTo: convertDateToMoment(row.PricingEffectiveTo),
        equipmentTypeDetail: row.TrailerDescription,
        error_message: row.ErrorMessage,
        flagStandardTranit: '',
        freightAccessorialCollection: row.Accessorials,
        grossCharge: row.GrossCharge,
        isRateEntry: null,
        items: row.Details
          ? row.Details.map((item) => ({
              ...item,
              ABSMaximumUsed: item.ABSMaximumUsed,
              ABSMinimumUsed: item.ABSMinimumUsed,
              actualClass: item.ActualClass,
              actualWeight: item.ActualWeight,
              billedQuantity: item.BilledQuantity,
              billedWeight: item.BilledWeight,
              billedWeightUOM: item.BilledWeightUOM,
              discountAmount: item.DiscountAmount,
              numberOfPieces: item.NumberOfPieces,
              pricingBasis: item.PricingBasis,
              rateCharge: item.RateCharge,
              rateCostPer: item.RateCostPer,
              ratingClass: String(item.RatingClass),
              totalCharge: item.TotalCharge,
            }))
          : [],
        laneCode: row.LaneCode || 'N/A',
        laneId: row.LaneId,
        laneKey: row.LaneKey || 'N/A',
        liner: row.AirRailOceanLiner || 'N/A',
        lineType: row.AirRailEquipmentType || 'N/A',
        mileage: row.MileageMiles,
        mileageKm: row.MileageKilometers,
        note: row.ErrorMessage,
        pricingBasis: row.PricingBasis,
        pricingDetailKey: row.PricingKey,
        pricingEffectiveFrom: pricingEffectiveFrom ? pricingEffectiveFrom?.format('(DD-MMM-YYYY)') : '',
        pricingEffectiveTo: pricingEffectiveTo ? pricingEffectiveTo?.format('(DD-MMM-YYYY)') : '',
        pricingType: row.PricingType,
        rateShopKey: '',
        rateType: '',
        serviceDesc: row.ServiceDescription,
        serviceKey: row.ServiceKey,
        serviceType: row.ServiceCode,
        shipmentCost: row.ShipmentCost,
        spotQuoteNumber: row.SpotQuoteContractNumber,
        standardDaysTransit: row.StandardDaysTransit,
        TariffKey: row.TariffKey,
        tariffEffectiveFrom: tariffEffectiveFrom ? tariffEffectiveFrom?.format('(DD-MMM-YYYY)') : '',
        tariffEffectiveTo: tariffEffectiveTo ? tariffEffectiveTo?.format('(DD-MMM-YYYY)') : '',
        tariffKey: row.TariffKey,
        tariffName: row.TariffName,
        tariffRateDate: tariffRateDate ? tariffRateDate?.format('(mm/dd/yyyy)') : '',
        taxes: row.Taxes
          ? row.Taxes.map((tax) => ({
              ...tax,
              auditedChargeAmount: tax.AuditedChargeAmount,
              calculationType: tax.CalculationType,
              description: tax.Description,
              effectiveFromDate: formateWithMoment(tax.EffectiveFromDate, 'DD-MMM-YYYY'),
              effectiveToDate: formateWithMoment(tax.EffectiveToDate, 'DD-MMM-YYYY'),
              note: tax.ErrorMessage,
              taxCode: tax.TaxCode,
              taxType: tax.TaxType,
            }))
          : [],
        totalAccessorialCharge: row.TotalAccessorialCharge,
        totalDeficitCharge: row.TotalDeficitCharge,
        totalDeficitWeight: row.TotalDeficitWeight,
        totalDiscount: row.TotalDiscount,
        totalShipmentCost: row.TotalShipmentCost,
        totalTaxCharge: row.TotalTaxCharge,
        trailerDesc: row.TrailerDescription,
        trailerkey: row.TrailerKey,
        viewCargoType: null,
      };
    });
  }
  data = data.filter(({ totalShipmentCost }) => {
    return Number(totalShipmentCost) > 0;
  });
  data = orderBy(data, ['totalShipmentCost'], ['asc']);
  // TODO: use native Object.groupBy
  return groupBy(data, ({ laneId }) => laneId);
};

export const convertParcelExpressUIToRateAPI = (data, customerKey, isRateRequest) => {
  const carrierData = isRateRequest
    ? {
        dhlAccount: valueToString(data?.carrierForm?.dhlAccount),
        fedexAccount: valueToString(data?.carrierForm?.fedexAccount),
        rateDHL: Boolean(data?.carrierForm?.rateDHL),
        rateFedex: Boolean(data?.carrierForm?.rateFedex),
        rateUPS: Boolean(data?.carrierForm?.rateUPS),
        ShipmentTerms: valueToString(data?.shipmentInformationForm?.shipmentTerms),
        shipperAccountNo: valueToString(data?.shipmentInformationForm?.shipperAccountNo),
        upsAccount: valueToString(data?.carrierForm?.upsAccount),
      }
    : {
        declaredValue: valueToNumber(data?.shipmentInformationForm?.declaredValue),
        dhlAccount: '',
        dutyTaxAccountNo: valueToString(data?.shipmentInformationForm?.dutyTaxAccountNo),
        fedexAccount: '',
        LabelDHL: false,
        LabelFedex: false,
        LabelUPS: false,
        ShipmentTerms: valueToString(data?.shipmentInformationForm?.shipmentTerms),
        ShipmentType: valueToString(data?.shipmentInformationForm?.shipmentType),
        ShipperAccountNumber: valueToString(data?.shipmentInformationForm?.accountNo),
        shipperAccountNo: valueToString(data?.shipmentInformationForm?.shipperAccountNo),
        upsAccount: '',
      };

  if (!isRateRequest) {
    if (data.SelectedRate.carrierType === SP_CARRIERS_TYPES.FEDEX) {
      carrierData.LabelFedex = true;
      carrierData.fedexAccount = valueToString(data?.carrierForm?.fedexAccount);
    } else if (data.SelectedRate.carrierType === SP_CARRIERS_TYPES.UPS) {
      carrierData.LabelUPS = true;
      carrierData.upsAccount = valueToString(data?.carrierForm?.upsAccount);
    } else if (data.SelectedRate.carrierType === SP_CARRIERS_TYPES.DHL) {
      carrierData.LabelDHL = true;
      carrierData.dhlAccount = valueToString(data?.carrierForm?.dhlAccount);
    }
  }

  let shipDate;
  // If shipment time and shipTimeZone is provided then we need to merge the shipTime with shipDate and need to convert the selected timezone to UTC
  if (data.locationForm.shipDate && data.locationForm.shipTime && data.locationForm.shipTimeZone) {
    shipDate = mergeDateAndTimeObjectsWithTimeZone(
      moment(data.locationForm.shipDate),
      moment(data.locationForm.shipTime),
      data.locationForm.shipTimeZone,
    );
  } else {
    shipDate = data.locationForm.shipDate;
  }

  let latestPickupTime;
  // If shipment time and shipTimeZone is provided then we need to merge the shipTime with shipDate and need to convert the selected timezone to UTC
  if (data.locationForm.shipDate && data.locationForm.latestPickupTime && data.locationForm.shipTimeZone) {
    latestPickupTime = mergeDateAndTimeObjectsWithTimeZone(
      moment(data.locationForm.shipDate),
      moment(data.locationForm.latestPickupTime),
      data.locationForm.shipTimeZone,
    );
  }

  return {
    branch: valueToNumber(data?.shipmentInformationForm?.branchKey),
    customerKey: valueToNumber(customerKey),
    destination: {
      city: valueToString(data.locationForm?.DEST_city),
      companyName: valueToString(data.locationForm?.DEST_companyName),
      contactEmail: valueToString(data.locationForm?.DEST_contactEmail),
      contactName: valueToString(data.locationForm?.DEST_contactName),
      countryCode: valueToString(data.locationForm?.DEST_countryCode),
      deliveryDate: convertDateStringtoMoment(shipDate),
      phoneCode: valueToString(data.locationForm?.DEST_phoneCode),
      phoneExtension: valueToString(data.locationForm?.DEST_phoneExtension),
      phoneNumber: valueToString(data.locationForm?.DEST_phoneNumber),
      postalCode: valueToString(data.locationForm?.DEST_postalCode),
      state: valueToString(data.locationForm?.DEST_state),
      streetAddress: valueToString(data.locationForm?.DEST_streetAddress),
      streetAddress2: valueToString(data.locationForm?.DEST_streetAddress2),
    },
    origin: {
      city: valueToString(data.locationForm?.ORIGIN_city),
      companyName: valueToString(data.locationForm?.ORIGIN_companyName),
      contactEmail: valueToString(data.locationForm?.ORIGIN_contactEmail),
      contactName: valueToString(data.locationForm?.ORIGIN_contactName),
      countryCode: valueToString(data.locationForm?.ORIGIN_countryCode),
      deliveryDate: convertDateStringtoMoment(shipDate),
      phoneCode: valueToString(data.locationForm?.ORIGIN_phoneCode),
      phoneExtension: valueToString(data.locationForm?.ORIGIN_phoneExtension),
      phoneNumber: valueToString(data.locationForm?.ORIGIN_phoneNumber),
      postalCode: valueToString(data.locationForm?.ORIGIN_postalCode),
      state: valueToString(data.locationForm?.ORIGIN_state),
      streetAddress: valueToString(data.locationForm?.ORIGIN_streetAddress),
      streetAddress2: valueToString(data.locationForm?.ORIGIN_streetAddress2),
    },
    parcelPackage: data.packages.map((packageDetails) => ({
      dimensionsUOM: valueToString(packageDetails.dimensionsUOM),
      height: valueToString(packageDetails.height),
      length: valueToString(packageDetails.length),
      packagesQuantity: valueToNumber(packageDetails.noPackages),
      shipmentDetailsID: valueToNumber(packageDetails.shipmentDetailsID),
      weight: valueToString(packageDetails.weight),
      weightUOM: valueToString(packageDetails.weightUOM),
      width: valueToString(packageDetails.width),
    })),
    shipmentKey: valueToNumber(data.shipmentInformationForm?.shipmentKey),
    shipmentNumber: valueToString(data.shipmentInformationForm?.shipmentNo),
    ...carrierData,
    ...(latestPickupTime && !isRateRequest
      ? {
          latestPickupTime: convertDateStringtoMoment(latestPickupTime),
        }
      : {}),
  };
};

export const freightClassCalculator = (_productList, isHideTheRowDetails = false) =>
  new Promise((resolve, reject) =>
    (async () => {
      try {
        let productList = _productList || [];
        await validateProductForCalculateClass(productList, isHideTheRowDetails);
        productList = productList.map((row) => ({
          ...row,
          class: calCulateFreightClass(
            row.length,
            row.width,
            row.height,
            row.weight,
            row.weightUom,
            row.billQty,
            row.billQtyUom,
            row.dimUom,
            row.cube,
          ),
        }));
        resolve(productList);
      } catch (error) {
        reject(error);
      }
    })(),
  );

export const convertRateEntryToAPI = (data) => ({
  cargoType: valueToString(data?.cargoType),
  carrierKey: valueToNumber(data?.carrierKey),
  carrierName: valueToString(data?.carrierName),
  createdBy: valueToNumber(data?.createdBy),
  createdOn: truncateTimeZoneDate(convertDateUserLocalToUTCToEST(data?.createdOn)),
  currencyCode: valueToString(data?.currencyCode),
  shipmentCost: valueToNumber(data?.shipmentCost),
  shipmentKey: valueToNumber(data?.shipmentKey),
  standardDaysTransit: valueToNumber(data?.standardDaysTransit),
  trailerDesc: valueToString(data?.trailerDesc),
  trailerKey: valueToNumber(data?.trailerKey),
});

export const getShipmentOriginDestinationDetails = (_stops) => {
  const stops = orderBy(_stops, ['displaySequence'], ['asc']);

  return { destination: stops[stops.length - 1], origin: stops[0] };
};

export const alignStopsByStopNo = (_transportationList, index, _name) => {
  let transportationList = _transportationList || [];
  const seqParam = _name || 'displaySequence';
  const existIndexNo = transportationList?.findIndex(
    (row, indexLocal) => Number(row?.[seqParam]) === transportationList?.[index]?.[seqParam] && indexLocal !== index,
  );

  if (existIndexNo >= 0) {
    transportationList = arrayMove(transportationList, index, existIndexNo);
    transportationList = transportationList.map((row, index) => ({
      ...row,
      [seqParam]: index + 1,
    }));
    transportationList = orderBy(transportationList, [seqParam], ['asc']);
  }
  return transportationList;
};

export const generateStopsSequence = (_stops, index) => {
  let stops = _stops || [];
  stops = stops.map((row) => ({
    ...row,
    sequence: valueToNumber(row.sequence),
  }));
  stops[index].gridOperation = Number(stops[index].gridOperation);
  if (stops[index].gridOperation === 1) {
    // new stop
    stops[index].sequence = Math.max(...stops.map(({ sequence }) => (sequence ? sequence : 0))) + 1;
  } else if (stops[index].gridOperation === 2) {
    // modifying stop
    const stopsByType = stops.filter((stop) => stop.stopType === stops[index].stopType);
    const stopsBySequence = stopsByType.filter((stop) => stop.sequence === stops[index].sequence);

    if (stopsBySequence.length > 1) {
      stops[index].sequence = Math.max(...stopsByType.map(({ sequence }) => (sequence ? sequence : 0))) + 1;
    }
  } else if (stops[index].gridOperation === 3) {
    // deleting stop
  }
  return stops;
};

export const getShippingLabelPrintData = (shipmentDetails, _customerKey) => {
  let customerKey = _customerKey || 0;
  customerKey = Number(customerKey);
  const shipperInfo = shipmentDetails?.transportationList?.[0] ? shipmentDetails?.transportationList?.[0] : {};
  const consigneeInfo =
    shipmentDetails?.transportationList?.length > 0
      ? shipmentDetails?.transportationList?.[shipmentDetails?.transportationList?.length - 1]
      : {};
  const data = {
    bolNumber: shipmentDetails?.bolNumber,
    carrierName: shipmentDetails?.carrierName,
    consigneeAddress1: customerKey === 6027 ? '8800 WESTPAIN DR' : consigneeInfo?.address1,
    consigneeAddress2:
      customerKey === 6027
        ? 'HOUSTON, TX 77041'
        : `${consigneeInfo?.city}, ${consigneeInfo?.stateCode} ${consigneeInfo?.zipCode}`,
    consigneeName: customerKey === 6027 ? 'CELEROS FLOW TECHNOLOGY (FLOW AMERICA LLC)' : consigneeInfo?.name,
    consigneePhone: consigneeInfo?.businessPhone,
    proNo: shipmentDetails?.proNo,
    purchaseOrderNumber: shipmentDetails?.purchaseOrderNumber,
    salesOrderNumber: shipmentDetails?.salesOrderNumber,
    serviceLevel: shipmentDetails?.serviceLevel,
    shipperAddress1: customerKey === 6027 ? '8800 WESTPAIN DR' : shipperInfo?.address1,
    shipperAddress2:
      customerKey === 6027
        ? 'HOUSTON, TX 77041'
        : `${shipperInfo?.city}, ${shipperInfo?.stateCode} ${shipperInfo?.zipCode}`,
    shipperName: customerKey === 6027 ? 'CELEROS FLOW TECHNOLOGY (FLOW AMERICA LLC)' : shipperInfo?.name,
    shipperPhone: shipperInfo?.businessPhone,
  };
  return data;
};

export const constructDataForRateEngine = async (props) => {
  const { shipmentDetailsLocal, filterData, shipmentBranches, accountingFormData, havingAccessForMenu, isAPIRateShop } =
    props;
  let accessorials = [];
  if (accountingFormData?.accessorials) {
    accessorials = accountingFormData?.accessorials
      .filter((accessorial) => (havingAccessForMenu ? accessorial.isChecked === true : true))
      ?.map((row) => ({
        AccessorialCode: row.accChargeType?.trim(),
        BilledAmount: 0,
        CurrencyCode: null,
        Description: row.codeDesc,
      }));
  }

  const branchDetails = shipmentBranches?.find(({ branchKey }) => branchKey === shipmentDetailsLocal.branchKey);
  filterData.cargoType = filterData.cargoType?.length ? filterData.cargoType.join(',') : '';
  const formData = shipmentRateShopLocalToRateEngineAPI(
    accessorials,
    shipmentDetailsLocal,
    filterData,
    branchDetails?.currencyCode ? branchDetails?.currencyCode : '**',
    isAPIRateShop,
  );
  formData.isNeedToSave = true;
  formData.isAPIRateShop = isAPIRateShop;
  return formData;
};

//NOTE - To remove the products if a product having zero values for certain fields.
//NOTE - For now this function used in parcel express after getting products from API.
export const filterZeroValuesProducts = (products) =>
  products.filter(
    ({ weight, billQty, height, length, width }) => weight > 0 && billQty > 0 && height > 0 && length > 0 && width > 0,
  );

export const generatePayloadForCheckAddress = (data) => ({
  destination: {
    addr1: data.destination.streetAddress,
    addr2: data.destination.streetAddress2,
    branchKey: data.branch,
    city: data.destination.city,
    contactEmail: data.destination.contactEmail,
    contactName: data.destination.contactName,
    countryCode: data.destination.countryCode,
    customerKey: data.customerKey,
    name: data.destination.companyName,
    phone: data.destination.phoneNumber,
    phoneExt: data.destination.phoneExtension,
    state: data.destination.state,
    zip: data.destination.postalCode,
  },
  origin: {
    addr1: data.origin.streetAddress,
    addr2: data.origin.streetAddress2,
    branchKey: data.branch,
    city: data.origin.city,
    contactEmail: data.origin.contactEmail,
    contactName: data.origin.contactName,
    countryCode: data.origin.countryCode,
    customerKey: data.customerKey,
    name: data.origin.companyName,
    phone: data.origin.phoneNumber,
    phoneExt: data.origin.phoneExtension,
    state: data.origin.state,
    zip: data.origin.postalCode,
  },
});
